import {
  ComponentProps,
  ElementType,
  FC,
  HTMLAttributes,
  ReactNode,
} from "react";
import { type VariantProps } from "class-variance-authority";

import { I18nKeyType } from "@libs/i18n";
import { useTranslate } from "@/hooks/useTranslate";
import { cn } from "@/utils/tailwind";

import { textVariants, TextVariantType } from "./variants";

export type RmTextPropsType = ComponentProps<"p"> &
  HTMLAttributes<HTMLHeadingElement> &
  VariantProps<typeof textVariants> & {
    as?: ElementType;
  } & {
    children?: ReactNode;
    i18nKey?: I18nKeyType;
    i18nOptions?: object;
  };

const parseComponent = (variant?: TextVariantType | null) => {
  switch (variant) {
    case "title":
      return "h1";
    case "headerOne":
      return "h2";
    case "headerTwo":
      return "h3";
    case "headerThree":
      return "h4";
    default:
      return "p";
  }
};

export const RmText: FC<RmTextPropsType> = ({
  as,
  className,
  variant,
  weight,
  i18nKey,
  i18nOptions,
  children,
  ...props
}) => {
  const Comp = as ?? parseComponent(variant);
  const i18nText = useTranslate(i18nKey, i18nOptions);

  return (
    <Comp
      className={cn(textVariants({ variant, weight, className }))}
      {...props}>
      {children ?? i18nText}
    </Comp>
  );
};
